module.exports = "/shifts/components/eventTinyLineWithClockComponent-dbb644.html";